// WHAT CAN BE CHANGED?
// Change the background colour, font and text colour down below
// Don't change the title in this file

<template>
  <div class="content-header">
    <h2>{{ headerTitle }}</h2>
  </div>
</template>

<script>
export default {
  props: ["headerTitle"],
};
</script>

<style lang="scss" scoped>
//Component Styling
$content-header__background--colour: #ff6600;
$content-header__text--font: "Lato";
$content-header__text--colour: #FFFFFF;


.content-header {
    box-sizing: border-box;
    width: calc(100vw - 32px);
    max-width: 768px;
    background-color: $content-header__background--colour;
    font-family: $content-header__text--font;
    color: $content-header__text--colour;
    margin-bottom: 16px;
    padding: 3px 13px;
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    .content-header {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    .content-header {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    .content-header {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    .content-header {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    .content-header {
       
    }
}
</style>